import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-mist" data-id="element-65" data-mp="38n415zsrtsyv">
      <div className="max-w-5xl mx-auto" data-id="element-66" data-mp="3djavswfpvi1i">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy text-center mb-12 uppercase" data-id="element-67" data-mp="3dkcijy63hsz2">
          Everything Included in <span className="text-cta" data-id="element-68" data-mp="3mksl95f0kw2v">Scuba Diving Instructor Ready</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-69" data-mp="3mifty1nd99d5">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-navy border-b-4 border-cta rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-70" data-mp="11u9z9qbfwiri">
              <Icon size={28} className="text-cta" aria-hidden="true" data-id="element-71" data-mp="1i7q6uu5s31i5" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-72" data-mp="1dc146hygp4hm">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-73" data-mp="148zygididfeh">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3" data-id="element-74" data-mp="zd1fxbev2rlz">
              <span className="w-9 h-9 rounded-lg bg-mist text-ocean flex items-center justify-center shrink-0" data-id="element-75" data-mp="pm6sw4tsjnzh">
                <Icon size={18} aria-hidden="true" data-id="element-76" data-mp="kndabxznd6sg" />
              </span>
              <span className="text-navy font-bold text-xs uppercase leading-tight" data-id="element-77" data-mp="gkqgxsnbvdt5">{label}</span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-cta rounded-3xl p-8 md:p-12 shadow-xl shadow-navy/10 text-center" data-id="element-78" data-mp="bm5r8n5pcciy">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-2xl h-auto mx-auto mb-8" loading="lazy" data-id="element-79" data-mp="3t41lmleppomc" />
          <p className="text-2xl md:text-3xl font-serif font-extrabold text-navy mb-3" data-id="element-80" data-mp="kqch7bsfoign">
            SCUBA DIVING INSTRUCTOR <span className="text-cta" data-id="element-81" data-mp="pp5js966mp21">READY</span>
          </p>
          <p className="text-base text-slate-700 max-w-2xl mx-auto mb-8" data-id="element-82" data-mp="axwyudd85rv8">
            150 ready-to-teach scuba lessons designed to help instructors plan less, explain
            underwater skills more clearly and guide students from beginner foundations toward
            stronger control and confidence.
          </p>
          <p className="text-4xl md:text-5xl font-serif font-extrabold text-cta mb-6" data-id="element-83" data-mp="18fx3a3jvvvu5">$27 USD</p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-84" data-mp="2t24v1nubyv1h">
            GET THE COMPLETE SCUBA TEACHING SYSTEM NOW
          </Button>
          <p className="text-xs text-slate-500 mb-10" data-id="element-85" data-mp="2xufvcrszgiuk">
            Immediate Access · Complete 6-in-1 System · One-Time Payment
          </p>
          <div className="pt-8 border-t border-slate-200" data-id="element-86" data-mp="2a5wv8zk37cdk">
            <p className="text-2xl md:text-3xl font-serif font-bold text-navy mb-2 uppercase" data-id="element-87" data-mp="256tuhrb53sbe">
              Stop Building Every Lesson From Scratch.
            </p>
            <p className="text-lg font-semibold text-cta" data-id="element-88" data-mp="2j3p3xkvazlrz">
              Open the system. Choose the lesson. Show the visual. Teach.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}